import { render, staticRenderFns } from "./ChinaMapEchart.vue?vue&type=template&id=65e1d210&"
import script from "./ChinaMapEchart.vue?vue&type=script&lang=js&"
export * from "./ChinaMapEchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports